// import { transparentize } from "polished";
import styled from "styled-components";

export const BrandContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.2s ease;
  margin-top: 1rem;

  &:hover {
    opacity: 0.75;
  }

  // h5 {
  //   margin-left: $ {(props) => props.theme.global.padding.small};
  //   font-size: $ {(props) => props.theme.global.typography.h5.fontSize};
  //   font-weight: $ {(props) => props.theme.global.typography.text.fontWeight};
  // }

  // @media (min-width: $ { (props) =>
  //  props.theme.global.breakpoints.large.value}) {
  //   padding-top: 0;
  // }
`;

export const BrandIcon = styled.div`
  display: block;
  width: 52px;
  height: 52px;

  img {
    width: 100%;
  }
`;

export const NavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

export const NavItemIcon = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
`;

export const NavItem = styled.div<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  min-height: 42px;
  margin: 0.5em;
  opacity: ${(props) => (props.isActive ? 1 : 0.75)};
  font-weight: ${(props) => (props.isActive ? 500 : 400)};
  border-radius: 0.5em;
  color: ${(props) =>
    props.isActive ? props.theme.colors.primary1 : props.theme.colors.text1};

  cursor: pointer;
  // padding-left: $ {(props) => props.theme.global.padding.xsmall};
  // padding-right: $ {(props) => props.theme.global.padding.xsmall};

  transition: background-color 1s cubic-bezier(0.2, 0, 0, 1) 0s,
    color 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;

  // svg {
  //   fill: $ {(props) => props.theme.global.colors.secondaryColor};
  //   transition: fill 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
  // }

  &:hover {
    opacity: 1;
  }

  &.active {
    // opacity: 1;
    // font-weight: 500;
    // background-color: $ {(props) =>
    //   transparentize(0.9, props.theme.global.colors.brand)};
    // color: $ {(props) => props.theme.global.colors.brand};

    // svg {
    //   fill: $ {(props) => props.theme.global.colors.brand};
    // }
  }
`;

export const NavItemText = styled.span``;

export const SidebarContainer = styled.aside<{
  isCollapsed: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: 0;
  min-width: 0;
  flex-grow: 0;
  flex-shrink: 0;
  height: 100%;
  background: ${(props) => props.theme.colors.bg1};
  border-right: 1px solid #e5e5e5;
  // border-top: 1px solid $ {(props) => props.theme.global.colors.border.normal};

  // & > *:first-child {
  //   margin-top: $ {(props) => props.theme.global.padding.medium};
  // }

  // & > *:last-child {
  //   margin-bottom: $ {(props) => props.theme.global.padding.medium};
  // }

  // & > $ {NavWrapper}:last-child {
  //   border-top: 0;
  // }

  ${(props) =>
    props.isCollapsed
      ? `
      max-width: 70px;
      h5, ${NavItemText} {
        display: none;
      }
      ${BrandContainer} {
        padding-left: 1rem;
      }
      ${BrandIcon} img {
        max-width: 70%;
      }
      `
      : `
      width: 200px;
      `}
`;

export const SecondarySidebarContainer = styled.div`
  height: 100%;
  width: 270px;
  background: ${(props) => props.theme.colors.bg1};
`;
